import { render } from "./UserSalonList.vue?vue&type=template&id=251d44e6"
import script from "./UserSalonList.vue?vue&type=script&lang=js"
export * from "./UserSalonList.vue?vue&type=script&lang=js"

import "./UserSalonList.vue?vue&type=style&index=0&id=251d44e6&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__